<template>
	<div class="qr">
		<!-- 드래그 버전 설문 모달 -->
		<reservedayModalCreatewaiting
			:setdialog="reserveDialog"
			:title="placeTitle"
			:reservedaysData="reservedaysData"
		></reservedayModalCreatewaiting>
	</div>
</template>

<script>
import { reservedayModalCreatewaiting } from '@/components/index.js'
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'
export default {
	components: {
		reservedayModalCreatewaiting,
	},
	data() {
		return {
			reservedaysData: { business: { QRlogo: null } },
			placeTitle: '',

			reserveDialog: {
				title: '예약정보',
				dialog: false,
				dialog1: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		loc_firstSelect(val) {
			this.$store.state.searchsel_city2.items = location1[val].sort()
		},
		loc_twoSelect(val) {
			this.$store.state.searchsel_city3.items = location2[this.$store.state.searchsel_city1.value][val].sort()
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		close() {
			//창닫기
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
			document.getElementById('closeWaiting').click()
		},
		reservedays() {
			const data = {
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
			}
			this.$store.dispatch('reservedays', data).then(res => {
				if (res.data.reservedays[0].business) {
					if (res.data.reservedays[0].business.term) this.$store.state.termId = res.data.reservedays[0].business.term.id
					let li = []
					if (res.data.reservedays[0].business.useTerm) {
						li.push(res.data.reservedays[0].business.useTerm)
					} else li.push(null)
					if (res.data.reservedays[0].business.privacyTerm_waiting) {
						li.push(res.data.reservedays[0].business.privacyTerm_waiting)
					} else li.push(null)
					if (res.data.reservedays[0].business.uniqueTerm) {
						li.push(res.data.reservedays[0].business.uniqueTerm)
					} else li.push(null)
					if (res.data.reservedays[0].business.marketingTerm_reserveday) {
						li.push(res.data.reservedays[0].business.marketingTerm)
					} else li.push(null)
					if (res.data.reservedays[0].business.adTerm) {
						li.push(res.data.reservedays[0].business.adTerm)
					} else li.push(null)

					this.$store.state.termIdList = li
				}
				this.reservedaysData = res.data.reservedays[0]
				// reservedays data 초기화
				// this.$store.state.reservedayData = res.data.reservedays[0]
				this.$store.state.reservedayData = JSON.parse(JSON.stringify(res.data.reservedays[0]))
				if (res.data.reservedays[0].consultingTitle) {
					this.$store.state.reservedayData.title = res.data.reservedays[0].consultingTitle
				}
				if (res.data.reservedays[0].business.color) {
					this.$store.state.PointColor7 = res.data.reservedays[0].business.color
				}
				if (res.data.reservedays[0].business.btnColor) {
					this.$store.state.PointColor8 = res.data.reservedays[0].business.btnColor
				}
				// tplCode 초기화
				// this.$store.state.reservedayTplCode = this.reservedaysData.tplCode[0]
				// 설문 데이터 value 삽입
				if (res.data.reservedays[0].input_box !== null) {
					this.placeTitle = res.data.reservedays[0].title
					res.data.reservedays[0].input_box.categories.forEach(element => {
						if (element.tag === 'location') {
							if (element.defalutLocation) {
								this.$store.state.searchsel_city1.value = element.defalutLocation.split('_')[0]
								this.loc_firstSelect(element.defalutLocation.split('_')[0])
								if (element.defalutLocation.split('_')[1]) {
									this.loc_twoSelect(element.defalutLocation.split('_')[1])
									this.$store.state.searchsel_city2.value = element.defalutLocation.split('_')[1]
								}
								if (element.defalutLocation.split('_')[2]) {
									this.$store.state.searchsel_city3.value = element.defalutLocation.split('_')[2]
								}
							} else {
								this.$store.state.searchsel_city2.items = location1['서울특별시'].sort()
								this.$store.state.searchsel_city3.items = location2['서울특별시']['강남구'].sort()
							}
						}
						if (element.type === 10) {
							element.value = ''
							element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
							element.nowRadioValue = ''
							element.etc = ''
						} else if (element.type === 11) {
							element.category_details.forEach(detail => {
								if (!element.items) {
									element.items = []
								}
								element.items.push({
									value: '',
									label: detail.detailname,
									color: '',
									class: '',
									errorMessage: '',
									hideDetail: true,
									detailcode: detail.detailcode,
								})
							})
						} else if (element.type === 12) {
							element.items = {
								label: '',
								value: '',
								errorMessage: '',
								hideDetail: true,
								outlined: true,
								color: this.$store.state.PointColor7,
							}
						} else if (element.type === 20) {
							element.items = {
								value: '',
								maxlength: '255',
								outlined: true,
								autofocus: false,
								hideDetail: false,
								errorMessage: '',
								color: this.$store.state.PointColor7,
							}
						}
					})
				} else {
					// this.noInputBox = true
					this.alertModal2.text = '연결된 설문 정보가 없습니다. 등록고객 관리에서 설문정보를 등록해주세요.'
					this.alertModal2.dialog = true
					this.btnDisabled = true
					this.placeTitle = res.data.reservedays[0].title
				}
				this.$store.commit('reservedayInputBox', res.data.reservedays[0].input_box)
				// this.$store.commit('maxcount', res.data.reservedays[0].maxcount)
				// this.$store.commit('nodaySetting', res.data.reservedays[0].nodaySetting)
				// this.$store.commit('timeRange', res.data.reservedays[0].timeRange)
				// this.$store.commit('startDate', res.data.reservedays[0].sdate)
				// this.$store.commit('endDate', res.data.reservedays[0].edate)
				// 사업지명 찾기
				this.reserveDialog.dialog = true
			})
		},
	},
	created() {
		if (this.$route.params.code === '09buhz2luv1') {
			this.$router.push({ name: 'createwaiting', params: { code: '09buhz2luv', groupcode: '09buhz2luv' } })
		}
		this.screenWidth = window.innerWidth
		setTimeout(() => {
			this.reservedays()
		}, 500)
	},
}
</script>
<style lang="scss">
.qr {
	background-color: white;
}
</style>
